import { fetchEndpoint } from '../server/network'

import store from '../store/index'


// 获取购物车商品分组列表
export const cartGet =({operator_uid}) =>fetchEndpoint('/v2/ecapi.cart.get','POST',
  {
    "X-ECAPI-POSTYPE":2,
    operator_uid:operator_uid
  }
)


// 从购物车删除删除
export const cartDelete =
  (goods,operator_uid) =>
  fetchEndpoint(
    '/v2/ecapi.cart.delete',
    'POST',
    {
      "X-ECAPI-POSTYPE":2,
      "good": goods,  // 购物车商品 id 数组
      operator_uid:operator_uid
    }
)


// 获取购物车商品数量   温超二期  2016-8-23
export const cartQuantity =
(operator_uid) =>
fetchEndpoint(
  '/v2/ecapi.cart.quantity',
  'POST',
  {
    "X-ECAPI-POSTYPE":2,
		"operator_uid":store.getters.getUser.id, //操作者id
  }
)


// 修改购物车商品数量
export const cartUpdate =
(good, amount) =>
fetchEndpoint(
  '/v2/ecapi.cart.update',
  'POST',
  {
    "X-ECAPI-POSTYPE":2,
    "good": good,  // 购物车商品 id
    "amount": amount,  // 数量
  }
)

// 添加商品到扫码购物车
export const barcode =(barcode, operator_uid) =>
fetchEndpoint(
  '/v2/ecapi.scanning.barcode',
  'POST',
  {
    "X-ECAPI-POSTYPE":2,
    "barcode": barcode,  // 商品条码
    "operator_uid": operator_uid,  //操作者的用户id
  }
)

// 扫码购物车列表接口
export const getScreenCartList =(operator_uid) =>
fetchEndpoint(
  '/v2/ecapi.screen.cart.get',
  'POST',
  {operator_uid:operator_uid,"X-ECAPI-POSTYPE":2}
)


// 修改商品数量接口
export const updateCart =(good,amount) =>
fetchEndpoint(
  '/v2/ecapi.cart.update',
  'POST',
  {
    "X-ECAPI-POSTYPE":2,
    good:good,    //购物车商品id
    amount:amount,  // 修改的数量
  }
)

// 删除商品接口
export const deleteCart =(good) =>
fetchEndpoint(
  '/v2/ecapi.cart.update',
  'POST',
  {
    "X-ECAPI-POSTYPE":2,
    good:good,    //购物车id 实例 good: [1803] good: [1796,1795,1794]
  }
)

// 购物车商品总价格接口
export const screenOrderPrice =() =>
fetchEndpoint(
  '/v2/ecapi.screen.order.price',
  'POST',
  {"X-ECAPI-POSTYPE":2,}
)


// 清空购物车接口
export const clearCart =(operator_uid) =>
fetchEndpoint(
  '/v2/ecapi.cart.clear',
  'POST',
  {"X-ECAPI-POSTYPE":2,
  operator_uid:operator_uid}
)



// WEBPACK FOOTER //
// ./src/api/scan-cart.js